import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useRef } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { CSSTransition } from 'react-transition-group';
import { Backdrop } from '../../primitives/Backdrop/index.js';
import { TransitionWrapper } from '../../primitives/Drawer/components/TransitionWrapper.js';
import { Portal } from '../../primitives/internal/Portal/index.js';
export const Drawer = ({
  open,
  anchor,
  fullWidth = false,
  children,
  onClose
}) => {
  const nodeRef = useRef(null);
  return _jsxs(Portal, {
    children: [_jsx(RemoveScroll, {
      enabled: open,
      children: _jsx(CSSTransition, {
        classNames: 'drawer-layout',
        in: open,
        timeout: 300,
        unmountOnExit: true,
        nodeRef: nodeRef,
        children: _jsx(TransitionWrapper, {
          ref: nodeRef,
          anchor: anchor,
          fullWidth: fullWidth,
          transitionName: 'drawer-layout',
          children: children
        })
      })
    }), _jsx(Backdrop, {
      open: open,
      onClick: onClose
    })]
  });
};